<template>
  <div class="ui-tabs-content">
	  <div id="hmtAreaTab" class="region-title"><h3>{{_ll('港澳台')}}</h3></div>
    <ul id="hmt-list" class="ui-con" >
      <mt-picker :slots="myAddressSlots" :itemHeight="setFont(70)" value-key="name" @change="onMyAddressChange"></mt-picker>
    </ul>
  </div>
</template>

<script>
import {Picker} from 'mint-ui'
import {setFont} from '../../util/util'
export default {
  name: 'HMTArea',
  data () {
    return {
      myAddressSlots: [{
        flex: 1,
        defaultIndex: 1,
        values: this.hmtList,
        className: 'slot1',
        textAlign: 'center'
      }, {
        flex: 1,
        values: [],
        className: 'slot2',
        textAlign: 'center'
      }, {
		  flex: 1,
		  values: [],
		  className: 'slot3',
		  textAlign: 'center'
	  }],
      mtPicker: {},
      myProvince: {},
      myCity: {},
      myCounty: {},
	  provinceCount: 0,
      cityCount: 0,
      countyCount: 0
    }
  },
  props: {
    hmtList: {
      type: Array,
      defaultValue: []
    },
    hmtAreaList: {
      type: Array,
      defaultValue: []
    },
	hmtCountyList: {
      type: Array,
      defaultValue: []
    },
	fromAddrObj: {
		selectCode: {
			type: String,
			defaultValue: ''
		},
		selectCityCode: {
			type: String,
			defaultValue: ''
		},
		selectProvinceCode: {
			type: String,
			defaultValue: ''
		}
	}
  },
  components: {
    'mt-picker': Picker
  },
  mounted: function () {
    // this.$nextTick(() => {
    //   this.myAddressSlots[0].defaultIndex = 0
    // })
  },
  activated: function () {
    if (this.myProvince.code && this.myCity.code) {
      if (this.myCity.code === 'HMTAREA') {
        this.$emit('receiveData', this.myProvince, null, null, true)
      } else {
        this.$emit('receiveData', this.myProvince, this.myCity, null, false)
      }
    }
  },
  watch: {
    hmtList: function (newHMTList) {
      if (newHMTList && newHMTList.length > 0) {
        if (this.provinceCount === 0 && this.fromAddrObj.selectProvinceCode
			&& this.fromAddrObj.selectProvinceCode !== 'HMT') {
          let selectProvince = newHMTList.find(value => value.code
			  === this.fromAddrObj.selectProvinceCode)
          if (selectProvince) {
            this.mtPicker.setSlotValue(0, selectProvince)
            this.provinceCount = 1
          }
        }
      }
    },
    hmtAreaList: function (newAreaList) {
      if (newAreaList !== undefined && newAreaList.length > 0) {
        this.mtPicker.setSlotValues(1, newAreaList)
        if (this.cityCount === 0 && this.fromAddrObj.selectCityCode
			&& this.fromAddrObj.selectCityCode !== 'HMTAREA') {
          let selectCity = newAreaList.find(value => value.code === this.fromAddrObj.selectCityCode)
          if (selectCity) {
            this.mtPicker.setSlotValue(1, selectCity)
            this.cityCount = 1
          } else {
			  this.mtPicker.setSlotValue(1, newAreaList[0])
		  }
        } else {
          this.mtPicker.setSlotValue(1, newAreaList[0])
        }
      }
    },
	hmtCountyList: function (newCountyList) {
		if (newCountyList != undefined && newCountyList.length > 0) {
			this.mtPicker.setSlotValues(2, newCountyList)
			if (this.countyCount === 0 && this.fromAddrObj.selectCode
				&& this.fromAddrObj.selectCode !== 'HMTCOUNTY') {
				let selectCounty = newCountyList.find(value => value.code === this.fromAddrObj.selectCode)
				if (selectCounty) {
					this.mtPicker.setSlotValue(2, selectCounty)
					this.countyCount = 1
				} else {
					this.mtPicker.setSlotValue(2, newCountyList[0])
				}
			} else {
				this.mtPicker.setSlotValue(2, newCountyList[0])
			}
		}
	}
  },
  methods: {
	  setFont,
    onMyAddressChange: function (picker, values) {
		this.mtPicker = picker
		if (values[0] && this.myProvince.code !== values[0].code) {
			this.myProvince = values[0]
			this.$emit('changeData', values[0].code, values[0].level)
		}
		if (values[1] && this.myCity.code !== values[1].code) {
			this.myCity = values[1]
			this.$emit('changeData', values[1].code, values[1].level)
		}
		if (values[0] && values[1] && values[2]) {
			if (values[2].code === 'HMTCOUNTY') {
			    this.$emit('receiveData', values[0], values[1], values[2], true)
			} else {
				this.$emit('receiveData', values[0], values[1], values[2], false)
			}
		}
	}
  }
}
</script>

<style lang="scss" scoped>
	.region-title {
		height: 100px;
		line-height: 100px;
		padding-left: 20px;
		border-top: 1px solid $gray-dark;
	}
</style>



// WEBPACK FOOTER //
// src/components/region/hmt-area.vue